import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-phone-icon',
  template: `
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
    >
      <path
        d="M131.453,115.753a9.782,9.782,0,0,0-9.818,9.743,9.637,9.637,0,0,0,1.41,5.03l-1.774,5.227,5.436-1.727a9.766,9.766,0,1,0,4.745-18.273Zm4.882,13.442a2.53,2.53,0,0,1-1.737,1.119c-.46.026-.473.357-2.982-.734a10.243,10.243,0,0,1-4.14-3.913,4.816,4.816,0,0,1-.926-2.61,2.786,2.786,0,0,1,.956-2.041.969.969,0,0,1,.68-.287c.2,0,.325,0,.471,0s.366-.03.556.475.644,1.748.7,1.874a.456.456,0,0,1,0,.436,1.734,1.734,0,0,1-.267.406c-.131.139-.274.315-.392.421s-.267.248-.13.5a7.493,7.493,0,0,0,1.331,1.774,6.8,6.8,0,0,0,1.968,1.309c.246.135.394.12.546-.041s.653-.7.83-.946.342-.195.569-.1,1.436.74,1.682.873.411.2.469.308a2.047,2.047,0,0,1-.19,1.177Z"
        transform="translate(-121.271 -115.753)"
        fill="#2acc16"
      />
    </svg>
  `,
  styles: [
    `
      svg {
        display: block;
      }
    `,
  ],
})
export class PhoneIconComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
